import React from 'react';

import { studioTheme, hexToRgba } from './studioTheme';
import {
  StudioWrap,
  Avatar,
  Identity,
  SourceLogo,
  Stars,
  DateText,
} from './StudioCardKit';
import { StudioBody, isMediaTestimonial, StudioMediaCard } from './StudioBody';

/**
 * Megaphone (widget type 17)
 *
 * One short quote set in heavy display type on a tinted, borderless card. The
 * loud card in a wall of quiet ones. Long reviews lean on the wall's existing
 * shorten-text clamp, so it stays readable when a review runs long.
 */
const MegaphoneCard = (props) => {
  const { cardItem, socialCardType } = props;
  const t = studioTheme(props);

  const tint = t.dark ? hexToRgba(t.brand, 0.16) : hexToRgba(t.brand, 0.08);

  /* One body type scale per card: the text testimonial and the video/audio
     summary must read as the same widget. */
  const bodyTextStyle = { fontSize: t.smallSize ? 19 : 21, lineHeight: 1.25, letterSpacing: '-0.02em' };

  /* A video or audio testimonial IS the card - the player already carries
     the name and work title, so none of the chrome below is drawn. Only the
     summary keeps this widget's look, as the panel it extends into. */
  if (isMediaTestimonial(cardItem, socialCardType)) {
    return (
      <StudioMediaCard
        cardItem={cardItem}
        socialCardType={socialCardType}
        t={t}
        enclosure={{
          borderRadius: 20,
          background: tint,
          /* the wall's custom card colour wins, as it does on the text card */
          ...(t.cardBackgroundObject || {}),
        }}
        summaryStyle={bodyTextStyle}
      />
    );
  }

  return (
    <StudioWrap>
      <div
        style={{
          position: 'relative',
          borderRadius: 20,
          padding: 24,
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          border: '1px solid transparent',
          background: tint,
          ...(t.cardBackgroundObject || {}),
        }}
      >

        <StudioBody
          t={t}
          cardItem={cardItem}
          socialCardType={socialCardType}
          mediaRadius={14}
          quoteLength={180}
          textStyle={bodyTextStyle}
        />

        <Stars t={t} cardItem={cardItem} size={14} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
          <Avatar cardItem={cardItem} size={32} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <Identity t={t} cardItem={cardItem} nameSize={13.5} subSize={12} />
          </div>
          <SourceLogo cardItem={cardItem} />
        </div>

        <DateText t={t} cardItem={cardItem} />
      </div>
    </StudioWrap>
  );
};

export default MegaphoneCard;
